// extracted by mini-css-extract-plugin
export default {"wrapper":"WithState_wrapper__tpx9o"};